// ChatMessage.js
import React from "react";
import { LiveChatStyles as styles } from "./chat.tailwind";
import parse from 'html-react-parser';
import { useSelector } from "react-redux";
import replay_btn from '../../../../../../assets/svgs/replay_btn.svg'
import { Tooltip } from "@mui/material";

const CommentaryMessage = ({ message, handleReplayCommentary }) => {
  const { tokens } = useSelector((state) => state.deployToken);

  const processMessageText = (text) => {
    // Match "ZX" where X is a number
    const zoneRegex = /Z(\d+)/g;

    // Replace "Zone X" with "Zone X(my token)" if the token exists
    const replacedText = text?.replace(zoneRegex, (match, zoneNumber) => {
      const token = tokens?.find(token => token?.zoneName === `Z${zoneNumber}`); // Assuming tokens are in the format { Z1: "token1", Z2: "token2", ... }

      return token ? `Zone ${zoneNumber} (Your Zone)` : match;
    });

    return replacedText;
  };
  const processedMessageText = processMessageText(message?.messageText);

  return (
    <div className={`mb-2`}>
      <div className={styles.commentaryMessageContainer}>
        {/* main Message Text */}
        <pre className={`${styles.commentaryMessage}`}>
          {parse(processedMessageText)}

          {message?.additionalComments && (
            <p className="mt-1">{message?.additionalComments}</p>
          )}

          {/* Replay Button */}
          {(message?.player1Zone || message?.player2Zone) && (
            <Tooltip title={window.screen.width > 500 ? "Replay" : ""} arrow>
              <button className="absolute bottom-1 right-1" onClick={() => handleReplayCommentary(message)}>
                <img src={replay_btn} alt="replay" className="w-[20px] screen-500:w-[22px]" />
              </button>
            </Tooltip>
          )}
        </pre>

      </div>
    </div>
  );
};

export default CommentaryMessage;
